import { ResolveFn } from '@angular/router';
import { GroupData } from '../../shared/models/group-overview.model';
import { inject } from '@angular/core';
import moment from 'moment';
import { WebsiteStoreService } from '../services/website-store.service';

export const groupResolver: ResolveFn<GroupData> = (route) => {
  const websiteStore = inject(WebsiteStoreService);

  const currentDate = moment().utc();
  const startOfMonth = currentDate.startOf('month').unix();
  const endOfMonth = currentDate.endOf('month').unix();

  return websiteStore.loadGroupData(
    +route.paramMap.get('id')!,
    startOfMonth,
    endOfMonth,
    startOfMonth,
    endOfMonth,
  );
};
